import { useMemo } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { MAX_TRIAL_DAYS, SUBSCRIPTION_STATUS } from '../helpers/const';
const useTrialMessage = _ref => {
  let {
    userTrialSubscriptions
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const trialMessage = useMemo(() => {
    if (!userTrialSubscriptions) return null;

    // User with no trials
    if (userTrialSubscriptions.length === 0) return null;
    const fewestDaysTrial = userTrialSubscriptions.reduce((prev, curr) => prev.daysRemaining < curr.daysRemaining ? prev : curr);

    //User with all expired trials
    if (fewestDaysTrial.status === SUBSCRIPTION_STATUS.EXPIRED) {
      return {
        text: userTrialSubscriptions.length === 1 ? T.translate('BANNER_MESSAGE_EXPIRED_SINGLE') : T.translate('BANNER_MESSAGE_EXPIRED_MULTIPLE', {
          trialsToExpire: userTrialSubscriptions.filter(_ref3 => {
            let {
              status
            } = _ref3;
            return status === SUBSCRIPTION_STATUS.EXPIRED;
          }).length
        }),
        daysLeft: 0
      };
    }

    //User with active trials
    //Start of trial
    if (fewestDaysTrial.daysRemaining >= MAX_TRIAL_DAYS) {
      return {
        text: userTrialSubscriptions.length === 1 ? T.translate('BANNER_MESSAGE_ACTIVE_TRIAL_START_SINGLE', {
          offeringCategory: fewestDaysTrial.offeringCategoryName
        }) : T.translate('BANNER_MESSAGE_ACTIVE_TRIAL_START_MULTIPLE'),
        daysLeft: fewestDaysTrial.daysRemaining
      };
    }

    //Trial started
    return {
      text: userTrialSubscriptions.length === 1 ? T.translate('BANNER_MESSAGE_ACTIVE_TRIALS_SINGLE', {
        daysRemaining: fewestDaysTrial.daysRemaining,
        offeringCategory: fewestDaysTrial.offeringCategoryName
      }) : T.translate('BANNER_MESSAGE_ACTIVE_TRIALS_MULTIPLE', {
        daysRemaining: fewestDaysTrial.daysRemaining,
        trialsToExpire: userTrialSubscriptions.filter(_ref4 => {
          let {
            daysRemaining
          } = _ref4;
          return daysRemaining === fewestDaysTrial.daysRemaining;
        }).length
      }),
      daysLeft: fewestDaysTrial.daysRemaining
    };
  }, [userTrialSubscriptions, T]);
  return trialMessage;
};
export default useTrialMessage;
//# sourceMappingURL=useTrialMessage.js.map